import { Grid } from '@material-ui/core'
import { FC } from 'react'
import NavTabs from '../../../components/Navigation/Tabs/NavTabs'
import { DesktopMenuProps } from '../types'

const DesktopMenu: FC<DesktopMenuProps> = ({
  classes,
  doNavigation,
  navItems,
  currentPathEnd,
  unreadMessages
}) => {
  return (
    <Grid item md={8} lg={6} xl={4} className={classes.desktopMenu}>
      <NavTabs
        navigate={doNavigation}
        navItems={navItems}
        currentPath={currentPathEnd}
        unreadMessages={unreadMessages}
      />
    </Grid>
  )
}

export default DesktopMenu
